<template>
  <v-select
    v-model="selected"
    :items="options"
    item-text="name"
    item-value="value"
    label="Broadcast Quarter"
    @input="val => $emit('input', val)"
  ></v-select>
</template>

<script>
  export default {
    components: {
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      selected: {
        get () {
          if (this.options) {
            this.$emit('input', this.options[0].value)
            return this.options[0]
          }
          return ''
        },
        set (newVal) {
          this.$emit('input', newVal)
          // no action needed
        }
      },
      options () {
        let dateRanges = this.$store.state.appRes.dateRanges
        let availableQuarters = []
        let quartersMap = dateRanges.map(broadcastMonth => {
          let [year, month] = broadcastMonth['name'].split('-')
          return year + '_Q' + Math.ceil(month / 3)
        })

        let quarterValuesCount = this.countSameValues(quartersMap)

        for (const q in quarterValuesCount) {
          if (quarterValuesCount[q] === 3) {
            availableQuarters.push({name: q, value: q})
          }
        }
        availableQuarters.sort((a, b) => (a.name > b.name) ? -1 : 1)
        return availableQuarters
      },
    },
    methods: {
      countSameValues (arr) {
        const count = {}

        // Iterate through the array
        for (let i = 0; i < arr.length; i++) {
          const value = arr[i]

          // If value is not already a key in count object, add it with value 1
          if (!count.hasOwnProperty(value)) {
            count[value] = 1
          } else {
            // If value is already a key in count object, increment its value by 1
            count[value]++
          }
        }

        return count
      },
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// BroadcastQuarterSelect.vue?d968db5c